import React, { useState, useEffect } from "react";
import axiosInstance from '../api/axiosInstance';
import { Container, Form } from "react-bootstrap";
import { FaCoins } from "react-icons/fa";

const ExchangeRate = () => {
  const [amount, setAmount] = useState("1"); // 초기값 "1"
  const [rates, setRates] = useState([]);

  // 각 통화별 매핑 플래그 이모지
  const flagEmojis = {
    USD: "🇺🇸", JPY: "🇯🇵", EUR: "🇪🇺", CNY: "🇨🇳",
    GBP: "🇬🇧", AUD: "🇦🇺", PHP: "🇵🇭", TWD: "🇹🇼", RUB: "🇷🇺"
  };

  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const response = await axiosInstance.get("https://blogapi.wajok.com/api/stock/getForexRecent");
        const filteredRates = response.data.response.filter((rate) => rate.code.includes(".KRW"));

        // 우선순위 설정
        const priority = ["USD", "JPY", "EUR", "CNY", "GBP", "AUD", "PHP", "TWD", "RUB"];
        // 우선순위대로 정렬
        filteredRates.sort((a, b) => {
          const indexA = priority.indexOf(a.currencyCode);
          const indexB = priority.indexOf(b.currencyCode);

          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;

          return indexA - indexB;
        });
        setRates(filteredRates);
      } catch (err) {
        console.log(`환율 데이터를 불러오는 중 오류 발생 : ${err}`);
      }
    }

    fetchExchangeRate();
  }, []);

  // 숫자 입력 필터링 및 천 단위 콤마 적용
  const formatNumber = (value) => {
    return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleChange = (e) => {
    const formattedValue = formatNumber(e.target.value);
    setAmount(formattedValue);
  };

  // 퀵 변환 단위 클릭 처리
  const handleQuickAmount = (val) => {
    setAmount(formatNumber(String(val)));
  };

  return (
    <div className="market-wrapper">
      <Container>
        {/* 입력 및 변환 조건 카드 */}
        <div className="market-search-card">
          <h4 className="fw-bold d-flex align-items-center gap-2 mb-3">
            <FaCoins className="text-warning" /> 환율 계산기
          </h4>
          <p className="text-muted small">
            외화 기준 금액을 입력하시면 주요 9개국 통화에 대한 한화(KRW) 환산 가치로 실시간 변환됩니다.
          </p>

          <Form.Group className="mb-2">
            <Form.Label className="fw-bold text-secondary" style={{ fontSize: '0.88rem' }}>기준 외화 금액 입력</Form.Label>
            <div className="d-flex align-items-center position-relative">
              <Form.Control
                type="text"
                value={amount}
                onChange={handleChange}
                className="medical-search-input text-end fw-bold"
                style={{ fontSize: '1.25rem', height: '52px', paddingRight: '70px' }}
              />
              <span className="position-absolute end-0 pe-3 text-secondary fw-bold" style={{ fontSize: '1.1rem', pointerEvents: 'none' }}></span>
            </div>
          </Form.Group>

          {/* 퀵 단위 버튼 그룹 */}
          <div className="quick-convert-group">
            {[1, 10, 100, 500, 1000, 10000].map((val) => (
              <button
                key={val}
                type="button"
                className="quick-convert-btn"
                onClick={() => handleQuickAmount(val)}
              >
                {val.toLocaleString()}
              </button>
            ))}
          </div>
        </div>

        {/* 환화 환산 결과 카드 그리드 */}
        <div className="currency-grid">
          {rates.map((rate, idx) => {
            const currencyClass = rate.currencyCode.toLowerCase();
            const flag = flagEmojis[rate.currencyCode] || "🌐";
            const numericAmount = parseFloat(amount ? amount.replace(/,/g, "") : 0);

            // 환율 환산 연산
            const converted = (numericAmount * rate.basePrice).toLocaleString(undefined, {
              maximumFractionDigits: 0
            });

            // 일본 엔화는 관습적으로 100엔(JPY) 단위로 환산 공시되는 경우가 많음
            const unitLabel = rate.currencyCode === "JPY" ? "100 JPY" : `1 ${rate.currencyCode}`;

            return (
              <div key={idx} className={`currency-card ${currencyClass}`}>
                <div className="currency-header">
                  <div>
                    <span className="currency-title">{rate.currencyCode}</span>
                    <div className="currency-country">{rate.country}</div>
                  </div>
                  <span className="currency-flag-icon">{flag}</span>
                </div>
                <div>
                  <div className="text-muted small">환산 금액 (KRW)</div>
                  <div className="currency-result-val">
                    {converted} <span style={{ fontSize: '1rem', fontWeight: 'normal', color: '#718096' }}>원</span>
                  </div>
                </div>
                <div className="currency-base-price">
                  1외화당 기준가: <span className="fw-bold text-dark">{rate.basePrice.toLocaleString()} KRW</span> ({unitLabel} 기준)
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export { ExchangeRate };
